import { render, staticRenderFns } from "./DataLake.vue?vue&type=template&id=1cbcbfc2&scoped=true"
import script from "./DataLake.vue?vue&type=script&lang=js"
export * from "./DataLake.vue?vue&type=script&lang=js"
import style0 from "./DataLake.vue?vue&type=style&index=0&id=1cbcbfc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbcbfc2",
  null
  
)

export default component.exports